let getAccessTokenSilently = null;
//based on https://github.com/auth0/auth0-react/issues/67
export const sec = {
    getAccessTokenSilently: () => getAccessTokenSilently,
    setAccessTokenSilently: (func) => (getAccessTokenSilently = func)
};